require('./_typed-array')('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});



//////////////////
// WEBPACK FOOTER
// /Users/yuki/Dropbox/Mac/Desktop/web design/dog-ema-wp/wp-content/themes/ema/node_modules/core-js/modules/es6.typed.uint16-array.js
// module id = 272
// module chunks = 0